import { observable } from 'mobx'
import { observer } from 'mobx-react'
import React from 'react'
import styled from 'styled-components'
import { ButtonSecondarySmall, ButtonSmall } from '../../../atoms/Button'
import { FieldNo } from '../../../atoms/FieldNo'
import { HideTablet } from '../../../atoms/HideTablet'
import { IntakeStepCol } from '../../../atoms/IntakeStepCol'
import { IntakeStepContainer } from '../../../atoms/IntakeStepContainer'
import { IntakeStepNoColTablet } from '../../../atoms/IntakeStepNoColTablet'
import { Label } from '../../../atoms/Label'
import { GetOwnIntakeQuery_getOwnIntake, UpdateOwnIntakeMutationVariables } from '../../../schema/schemaTypes'
// import bodyAreasImg from './body.png'
// import bodyAreasImg2x from './body@2x.png'

interface IProps {
  id: string
  active: boolean
  handleSubmit: (vars: UpdateOwnIntakeMutationVariables) => void
  intake: GetOwnIntakeQuery_getOwnIntake
  isCompleted: boolean
  label: string
  name: string
  no: number
}

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

const surgeryTypesByBodyAreaSpanish = [
  { label: 'Rostro', surgeryTypes: [
    { value: 'CLEFT_LIP_REPAIR', label: 'Reparación de labio leporino' },
    { value: 'CLEFT_PALATE_REPAIR', label: 'Reparación del paladar hendido' },
    { value: 'SEPTOPLASTY_SINUSOTOMY', label: 'Septoplastia/Sinusotomía' }, { value: 'TURBINATE_REDUCTION', label: 'Reducción de cornetes '},
    { value: 'CAUSTERIZING_OF_NOSTRILS', label: 'Cauterización nasal' },
   ] },
  { label: 'Ojo', surgeryTypes: [
    { value: 'STRABISMUS_REPAIR', label: 'Reparación de estrabismo' },
    { value: 'TEAR_DUCT_DILATION_OR_PROBING', label: 'Dilatación o sondeo del conducto lagrimal' },
    { value: 'EYE_TUBES', label: 'Tubos en los ojos' },
    { value: 'CHALAZION_REMOVAL', label: 'Eliminación del chalazión' },
    { value: 'CATARACT_REMOVAL', label: 'Extracción de cataratas' },
    { value: 'FRONTALIS_SUSPENSION', label: 'Suspensión del frontal' },
  ] },
  { label: 'Lengua', surgeryTypes: [
      {value: 'ANKYLOGLOSSIA_REPAIR', label: 'Reparación de Anquiloglosia'},
      {value: 'FRENULUM_REPAIR', label: 'Reparación de Frenulum'},
  ] },
  { label: 'Oídos', surgeryTypes: [
    { value: 'EAR_TUBES', label: 'Tubos en los oídos' },
    { value: 'EAR_DRUM_REPAIR', label: 'Reparación del tímpano' },
      { value: 'OTOPLASTY', label: 'Otoplastia' },
      { value: 'OTOSCOPY', label: 'Otoscopia' },
      { value: 'TYMPANOPLASTY', label: 'Timpanoplastia' },
      { value: 'BAER', label: 'BSAER' },

    ] },
  { label: 'Cuello / Garganta', surgeryTypes: [
    { value: 'TONSILLECTOMY', label: 'Amigdalectomía' },
    { value: 'ADENOIDECTOMY', label: 'Adenoidectomía' },
    { value: 'TONSILLECTOMY_ADENOIDECTOMY', label: 'Amigdalectomía y adenoidectomía' },
      { value: 'ENDOSCOPY_LARYNGOSCOPY', label: 'Endoscopia/Laringoscopia' },
      { value: 'BRONCHOSCOPY', label: 'Bronchoscopia' },
      { value: 'BRANCHIAL_CLEFT_CYST_REMOVAL', label: 'Extirpación de quistes de hendidura branquial' },

    ] },
  { label: 'Dolor de procedimiento', surgeryTypes: [
    { value: 'LUMBAR_PUNCTURE', label: 'Punción lumbar' },
    { value: 'CENTRAL_LINE_PLACEMENT', label: 'Colocación de la vía central' },
  ] },
  { label: 'Abdominal', surgeryTypes: [
    { value: 'APPENDECTOMY_OPEN_INCISION', label: 'Apendicectomía - incisión abierta' },
    { value: 'APPENDECTOMY_LAPAROSCOPIC_INCISION', label: 'Apendicectomía - incisión laparoscópica' },
    { value: 'COLONOSCOPY', label: 'Colonoscopia' },
    { value: 'HERNIA_REPAIR', label: 'Reparación de hernia' },
    { value: 'SIGMOIDOSCOPY', label: 'Sigmoidoscopia' },

  ] },
  { label: 'Mano', surgeryTypes: [
      {value: 'SYNDACTYLY_CORRECTION', label: 'Corrección de sindactilia'},
   ] },
  { label: 'Urología - chicos', surgeryTypes: [
    { value: 'CIRCUMCISION', label: 'Circuncisión' },
      { value: 'ORCHIOPEXY', label: 'Orquidopexia' },
      { value: 'PENILE_ADHESIONS', label: 'Adherencias del pene/puentes de piel' },
      { value: 'HYDROCELECTOMY', label: 'Hidrocelectomía' },
      { value: 'HYPOSADIUS_REPAIR', label: 'Reparación del hipospadias' },
      { value: 'CHORDEE_REPAIR', label: 'Reparación de la curvatura peneana'},
      { value: 'URETHRAL_FISTULA_REPAIR', label: 'Reparación de la fístula uretral' },
      { value: 'MEATOPLASTY', label: 'Meatoplastia' },
    ] },
  { label: 'Ortopédico', surgeryTypes: [
    { value: 'OSTEOTOMY', label: 'Osteotomía' },
    { value: 'BONE_SETTING_SPICA_CAST', label: 'Fijación de huesos/enyesado' },
    { value: 'TENDON_LENGTHENING_BONE_SPUR', label: 'Alargamiento del tendón/espolón óseo' },
      { value: 'HAMMER_TOE_REPAIR', label: 'Reparación de dedo del pie en martillo' },

      { value: 'OPEN_REDUCTION_OF_A_FRACTURE', label: 'Reducción abierta de una fractura' },
    { value: 'BONE_MARROW_ASPIRATION', label: 'Aspiración de médula ósea' },
  ] },
  { label: 'Piel', surgeryTypes: [
    { value: 'MOLE_REMOVAL', label: 'Eliminación de lunares' },
    { value: 'SCAR_REVISION_SKIN_GRAFT', label: 'Revisión de cicatrices/Injerto de piel' },
    ] },
]


const surgeryTypesByBodyAreaEnglish = [
  { label: 'Face', surgeryTypes: [
      { value: 'CLEFT_LIP_REPAIR', label: 'Cleft Lip Repair' },
      { value: 'CLEFT_PALATE_REPAIR', label: 'Cleft Palate Repair' },
      { value: 'SEPTOPLASTY_SINUSOTOMY', label: 'Septoplasty/Sinusotomy' },
      { value: 'CAUSTERIZING_OF_NOSTRILS', label: 'Causterizing of Nostrils' },
      { value: 'TURBINATE_REDUCTION', label: 'Reducción de cornetes '},
      { value: 'ANKYLOGLOSSIA_REPAIR', label: 'Ankyloglossia Repair' },
      { value: 'SYNDACTYLY_CORRECTION', label: 'Syndactyly Correction' },
    ] },
  { label: 'Eye', surgeryTypes: [
      { value: 'STRABISMUS_REPAIR', label: 'Strabismus Repair' },
      { value: 'TEAR_DUCT_DILATION_OR_PROBING', label: 'Tear Duct Dilation or Probing' },
      { value: 'EYE_TUBES', label: 'Eye Tubes' },
      { value: 'CHALAZION_REMOVAL', label: 'Chalazion Removal' },
      { value: 'CATARACT_REMOVAL', label: 'Cataract Removal' },
      { value: 'FRONTALIS_SUSPENSION', label: 'Frontalis Suspension' },
    ] },
  { label: 'Tongue', surgeryTypes: [
      {value: 'ANKYLOGLOSSIA_REPAIR', label: 'Reparación de Anquiloglosia'},
      { value: 'ENDOSCOPY_LARYNGOSCOPY', label: 'Endoscopy/Laryngoscopy' },
      { value: 'BRONCHOSCOPY', label: 'Bronchoscopy' },
      { value: 'BRANCHIAL_CLEFT_CYST_REMOVAL', label: 'Branchial Cleft Cyst Removal' },
    ] },
  { label: 'Ears', surgeryTypes: [
      { value: 'EAR_TUBES', label: 'Ear Tubes' },
      { value: 'EAR_DRUM_REPAIR', label: 'Ear Drum Repair' },
      { value: 'OTOPLASTY', label: 'Otoplasty' },
      { value: 'OTOSCOPY', label: 'Otoscopy' },
    ] },
  { label: 'Neck/Throat', surgeryTypes: [
      { value: 'HYDROCELECTOMY', label: 'Hydrocelectomy' },
      { value: 'HYPOSADIUS_REPAIR', label: 'Hyposadius Repair' },
      { value: 'TONSILLECTOMY', label: 'Tonsillectomy' },
      { value: 'ADENOIDECTOMY', label: 'Adenoidectomy' },
      { value: 'TONSILLECTOMY_ADENOIDECTOMY', label: 'Tonsillectomy & Adenoidectomy' },
    ] },
  { label: 'Procedural pain', surgeryTypes: [
      { value: 'BONE_MARROW_ASPIRATION', label: 'Bone Marrow Aspiration' },
      { value: 'LUMBAR_PUNCTURE', label: 'Lumbar Puncture' },
      { value: 'CENTRAL_LINE_PLACEMENT', label: 'Central Line Placements' },
    ] },
  { label: 'Abdominal', surgeryTypes: [
      { value: 'APPENDECTOMY_OPEN_INCISION', label: 'Appendectomy - open incision' },
      { value: 'APPENDECTOMY_LAPAROSCOPIC_INCISION', label: 'Appendectomy - laparoscopic incision' },
      { value: 'COLONOSCOPY', label: 'Colonoscopy' },
      { value: 'HERNIA_REPAIR', label: 'Hernia Repair' },
      { value: 'SIGMOIDOSCOPY', label: 'Sigmoidoscopy' },
      { value: 'ORCHIOPEXY', label: 'Orchiopexy' },
    ] },
  { label: 'Hand', surgeryTypes: [
      { value: 'URETHRAL_FISTULA_REPAIR', label: 'Urethral Fistula Repair' },
      { value: 'MEATOPLASTY', label: 'Meatoplasty' },
      { value: 'TYMPANOPLASTY', label: 'Tympanoplasty' },
      { value: 'BAER', label: 'BAER' },
    ] },
  { label: 'Urology - boys', surgeryTypes: [
      { value: 'CIRCUMCISION', label: 'Circumcision' },
    ] },
  { label: 'Orthopedic', surgeryTypes: [
      { value: 'OSTEOTOMY', label: 'Osteotomy' },
      { value: 'BONE_SETTING_SPICA_CAST', label: 'Bone Setting/Spica Cast' },
      { value: 'TENDON_LENGTHENING_BONE_SPUR', label: 'Tendon Lengthening/Bone Spur' },
      { value: 'OPEN_REDUCTION_OF_A_FRACTURE', label: 'Open Reduction of a Fracture' },
      { value: 'BONE_MARROW_ASPIRATION', label: 'Bone Marrow Aspiration' },
      { value: 'LUMBAR_PUNCTURE', label: 'Lumbar Puncture' },
      { value: 'CENTRAL_LINE_PLACEMENT', label: 'Central Line Placement' },
    ] },
  { label: 'Skin', surgeryTypes: [
      { value: 'MOLE_REMOVAL', label: 'Mole Removal' },
      { value: 'SCAR_REVISION_SKIN_GRAFT', label: 'Scar Revision/Skin Graft' },
      { value: 'HAMMER_TOE_REPAIR', label: 'Hammer Toe Repair' },
    ] },
]

let surgeryTypesByBodyArea = surgeryTypesByBodyAreaEnglish

if(process.env.REACT_APP_LANGUAGE === 'es'){
 surgeryTypesByBodyArea = surgeryTypesByBodyAreaSpanish
}

function findBodyAreaAndSurgeryTypeIndex (surgeryType: string | null) {
  if (surgeryType === null) { return [null, null] }
  for (let i = 0; i < surgeryTypesByBodyArea.length; i++) {
    const bodyAreaObj = surgeryTypesByBodyArea[i]
    for (let j = 0; j < bodyAreaObj.surgeryTypes.length; j++) {
      const surgeryTypeObj = bodyAreaObj.surgeryTypes[j]
      if (surgeryTypeObj.value === surgeryType) { return [i, j] }
    }
  }
  return [null, null]
}

@observer
export class IntakeStepInputSurgeryType extends React.Component<IProps> {
  @observable private bodyAreaIndex: number | null = null
  @observable private surgeryTypeIndex: number | null = null
  @observable private confirmed: boolean = false

  public componentWillMount() {
    const { intake, name } = this.props
    if (!intake[name]) { return }

    [this.bodyAreaIndex, this.surgeryTypeIndex] = findBodyAreaAndSurgeryTypeIndex(intake[name])
    this.confirmed = true
  }

  public render () {
    const { active, id, isCompleted, label, no, intake } = this.props

    console.log('selected index', this.bodyAreaIndex)

    const isPablo = intake.characterChoice === 'pablo'

    

    let imgSrc1 =  `https://uci-images.s3-us-west-1.amazonaws.com/images/${isPablo ? 'pablo/' : ''}screen18-0.png`
    let imgSrc2 = `https://uci-images.s3-us-west-1.amazonaws.com/images/${isPablo ? 'pablo/' : ''}screen18-0@2x.png 2x`

    if (this.bodyAreaIndex != null ) {
      imgSrc1 =  `https://uci-images.s3-us-west-1.amazonaws.com/images/${isPablo ? 'pablo/' : ''}screen18-${this.bodyAreaIndex + 1}.png`
      imgSrc2 = `https://uci-images.s3-us-west-1.amazonaws.com/images/${isPablo ? 'pablo/' : ''}screen18-${this.bodyAreaIndex + 1}@2x.png 2x`
    }

    let content = (
      <Row>
        <Col>
          {surgeryTypesByBodyArea.map((bodyArea, i) =>
            <SurgeryTypeButton selected={this.bodyAreaIndex === i}
              onClick={isCompleted ? undefined : this.handleClickBodyArea}
              value={i} key={bodyArea.label}>{bodyArea.label}</SurgeryTypeButton>,
          )}
        </Col>
        <Col>
          <Image src={imgSrc1} srcSet={imgSrc2} />
        </Col>
        <Col>
          {this.bodyAreaIndex !== null && surgeryTypesByBodyArea[this.bodyAreaIndex].surgeryTypes.map((obj, i) =>
            <SurgeryTypeButton selected={this.surgeryTypeIndex === i && this.confirmed}
              onClick={isCompleted ? undefined : this.handleClickSurgeryType}
              value={i}
              key={obj.label}>{obj.label}</SurgeryTypeButton>,
          )}
          {this.bodyAreaIndex !== null && this.surgeryTypeIndex !== null && !this.confirmed && (
            <Card>
              {lang === 'es' ? 'Seleccionó el tipo de cirugía:' : 'You selected the surgery type:'}
              <SurgeryType>
                {surgeryTypesByBodyArea[this.bodyAreaIndex].surgeryTypes[this.surgeryTypeIndex].label}
              </SurgeryType>
              <strong>{lang === 'es' ? 'Esta seguro?' : 'You sure?'}</strong>
              <ButtonRow>
                <ButtonSmall onClick={isCompleted ? undefined : this.handleClickConfirm}>{lang === 'es' ? 'SI' : 'YES'}</ButtonSmall>
                <ButtonSecondarySmall
                  onClick={isCompleted ? undefined : this.handleClickUnconfirm}
                  style={{ marginLeft: 10 }}>
                  NO
                </ButtonSecondarySmall>
              </ButtonRow>
            </Card>
          )}
        </Col>
      </Row>
    )

    if (window.innerWidth <= 768) {
      content = <Col>
        <Center>
          <SmallImage src={imgSrc1} srcSet={imgSrc2} />
        </Center>

        {surgeryTypesByBodyArea.map((bodyArea, i) =>
          <Col key={bodyArea.label}>
            <SurgeryTypeButton selected={this.bodyAreaIndex === i}
              onClick={isCompleted ? undefined : this.handleClickBodyArea}
              value={i} >{bodyArea.label}</SurgeryTypeButton>

            {this.bodyAreaIndex === i && surgeryTypesByBodyArea[this.bodyAreaIndex].surgeryTypes.map((obj, i2) =>
              <Col key={obj.label}>
                <div style={{height: 5}} />
                <SurgeryTypeButtonSmall  selected={this.surgeryTypeIndex === i2}
                  onClick={isCompleted ? undefined : this.handleClickSurgeryType}
                  value={i2}
                  key={obj.label}>{obj.label}</SurgeryTypeButtonSmall>
              </Col>,
            )}

          </Col>,
        )}


        {this.bodyAreaIndex !== null && this.surgeryTypeIndex !== null && !this.confirmed && (
          <MobileCard>
            {lang === 'es' ? 'Seleccionó el tipo de cirugía:' : 'You selected the surgery type:'}
          
            <SurgeryType>
              {surgeryTypesByBodyArea[this.bodyAreaIndex].surgeryTypes[this.surgeryTypeIndex].label}
            </SurgeryType>
            <strong>{lang === 'es' ? 'Esta seguro?' : 'You sure?'}</strong>
            <ButtonRow>
              <ButtonSmall onClick={isCompleted ? undefined : this.handleClickConfirm}>{lang === 'es' ? 'SI' : 'YES'}</ButtonSmall>
              <ButtonSecondarySmall
                onClick={isCompleted ? undefined : this.handleClickUnconfirm}
                style={{ marginLeft: 10 }}>
            NO
              </ButtonSecondarySmall>
            </ButtonRow>
          </MobileCard>
        )}

      </Col>

    }

    console.log('screen width',  window.innerWidth)

    return (
      <IntakeStepContainer id={id} active={active}>
        <IntakeStepNoColTablet>
          <FieldNo checked={isCompleted}>{no}</FieldNo>
        </IntakeStepNoColTablet>
        <IntakeStepCol>
          <Label><HideTablet><FieldNo checked={isCompleted}>{no}</FieldNo></HideTablet>{label}</Label>
          {process.env.REACT_APP_LANGUAGE === 'es' ? ' Algunos padres pueden estar preocupados por la ansiedad de su hijo durante la cirugía. A continuación le ofrecemos algunas opciones para que las tenga en cuenta el día de la cirugía.' : 'What type of surgery will your child be having? Click on the appropriate area of the body and select the surgery type.'}
          {content}
        </IntakeStepCol>
      </IntakeStepContainer>
    )
  }

  private handleClickBodyArea = (e: React.MouseEvent<HTMLButtonElement>) => {
    const parsedIndex = parseInt(e.currentTarget.value, 10)
    this.bodyAreaIndex = isNaN(parsedIndex) ? null : parsedIndex
    this.surgeryTypeIndex = null
    this.confirmed = false
  }

  private handleClickSurgeryType = (e: React.MouseEvent<HTMLButtonElement>) => {
    const parsedIndex = parseInt(e.currentTarget.value, 10)
    this.surgeryTypeIndex = isNaN(parsedIndex) ? null : parsedIndex
    this.confirmed = false
  }

  private handleClickConfirm = () => {
    this.confirmed = true
    const { handleSubmit, name } = this.props
    const val = surgeryTypesByBodyArea[this.bodyAreaIndex || 0].surgeryTypes[this.surgeryTypeIndex || 0].value
    handleSubmit({ [name]: val })
  }

  private handleClickUnconfirm = () => {
    this.surgeryTypeIndex = null
    this.confirmed = false
  }
}

const Row = styled.div`
  margin-top: 12px;
  display: flex;
`

const Col = styled.div`
  flex: 1 0 0px;
`

const Center = styled.div`
  flex: 1 0 0px;
  align-items: center;
  justify-content: center;
  display: flex;
`

const Image = styled.img``

const SmallImage = styled.img`
  max-width: 50%;
  margin-top: 20px;
  margin-bottom: 20px;
`

const SurgeryTypeButton = styled.button<{ selected: boolean }>`
  display: block;
  appearance: none;
  border: none;
  padding: 2px 17px;
  background: ${({ selected }) => selected ? '#FA8D2D' : 'none'};
  margin: 0;
  border-radius: 18px;
  text-align: left;

  font-family: Nunito;
  font-size: 22px;
  color: ${({ selected }) => selected ? 'white' : '#494798'};

  :focus, :hover, :active {
    color: ${({ selected }) => selected ? 'white' : '#6462C1'};
  }
`

const SurgeryTypeButtonSmall = styled.button<{ selected: boolean }>`
  display: block;
  appearance: none;
  border: none;
  padding: 2px 17px;
  background: ${({ selected }) => selected ? '#FA8D2D' : 'none'};
  border-radius: 18px;
  text-align: left;
  margin-left: 20px;

  font-family: Nunito;
  font-size: 22px;
  color: ${({ selected }) => selected ? 'white' : '#494798'};

  :focus, :hover, :active {
    color: ${({ selected }) => selected ? 'white' : '#6462C1'};
  }

`

const Card = styled.div`
  font-family: "SF Pro Display";
  font-size: 16px;
  color: #172129;

  padding: 20px;
  box-shadow: 0 8px 10px 0 #00000013;
  border-radius: 5px;
`

const MobileCard = styled.div`
  font-family: "SF Pro Display";
  font-size: 16px;
  color: #172129;
  padding: 20px;
  box-shadow: 0 8px 10px 0 #00000013;
  border-radius: 5px;
  position: fixed;
  top: 200px;
  z-index: 1;
  background: white;
`

const SurgeryType = styled.div`
  font-family: Nunito;
  font-size: 24px;
  font-weight: 600;
  color: #12385B;
  margin: 2px 0;
`

const ButtonRow = styled.div`
  margin-top: 11px;
`



// WEBPACK FOOTER //
// ./src/organisms/Intakes/IntakeStepInputSurgeryType/index.tsx